// ── Match display tiering (pure, shared by web + tests) ──────────────────────
//
// Decides which panel the match-detail UI renders, so it NEVER shows NaN for a
// semantic-only row (which has no LLM sub-scores):
//   "llm"      → full 6-dimension breakdown (llm_scored rows: bd.title present)
//   "quick"    → semantic-tier panel (real calibrated score, no LLM sub-scores —
//                covers semantic_only / auto_semantic_only / fallback_semantic_only
//                AND needs_jd null-breakdown rows that still carry a score)
//   "awaiting" → no LLM breakdown AND no meaningful score
export function matchDisplayTier(match) {
    const bd = match.scoreBreakdown;
    // Only an LLM row has the six weighted sub-scores. Gate on `title` presence —
    // NOT on `bd != null` (a semantic row's bd holds only `familyFit`).
    if (typeof bd?.title === "number" && Number.isFinite(bd.title))
        return "llm";
    const hasScore = Number.isFinite(match.weightedScore) && match.weightedScore > 0;
    return hasScore ? "quick" : "awaiting";
}
/** Qualitative similarity from a cosine value — the raw number is NOT exposed. */
export function similarityLabel(cosine) {
    if (cosine == null || !Number.isFinite(cosine))
        return null;
    return cosine >= 0.6 ? "Strong" : cosine >= 0.5 ? "Good" : cosine >= 0.4 ? "Moderate" : "Fair";
}
//# sourceMappingURL=match-display.js.map